import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox-universal';
import ThumbnailImage from './gallery/thumbnail_image';

export default class GalleryTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false
    };
  }

  componentDidMount() {
    window.addEventListener('hashchange', this.closeOnBack, false);
  }
  componentWillUnmount() {
    window.removeEventListener('hashchange', this.closeOnBack, false);
  }

  render() {
    let that = this;
    const images = this.props.images;
    const imageAlt = this.props.imageAlt;
    const { isOpen } = this.state;

    return (
      <div>
        <div className="offer-gallery-tab">
          <div className="offer-gallery-tab-inner-wrapper">
            {images.map(function(imgUrl, index) {
              return (
                <ThumbnailImage
                  key={index}
                  elemIndex={index}
                  imageUrl={imgUrl}
                  imageAlt={imageAlt}
                  onThumbnailClick={that.handleClick}
                />
              );
            })}
          </div>
        </div>
        {isOpen ? this.openLightbox(images) : ''}
      </div>
    );
  }

  openLightbox = images => {
    window.location.hash = 'hotel-gallery';
    return (
      <Lightbox
        mainSrc={images[this.state.photoIndex]}
        nextSrc={images[(this.state.photoIndex + 1) % images.length]}
        prevSrc={
          images[(this.state.photoIndex + images.length - 1) % images.length]
        }
        onCloseRequest={this.closeLightbox}
        onMovePrevRequest={() =>
          this.setState({
            photoIndex:
              (this.state.photoIndex + images.length - 1) % images.length
          })
        }
        onMoveNextRequest={() =>
          this.setState({
            photoIndex: (this.state.photoIndex + 1) % images.length
          })
        }
      />
    );
  };

  handleClick = event => {
    let photoIndex = parseInt(event.currentTarget.dataset.elementIndex);
    this.setState({ photoIndex: photoIndex, isOpen: true });
  };

  closeOnBack = () => {
    if (location.hash != '#hotel-gallery') {
      this.setState({ isOpen: false });
    }
  };

  closeLightbox = () => {
    this.setState({ isOpen: false });
    window.history.back();
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/gallery_tab.jsx